import { render, staticRenderFns } from "./WorkOrdersList.vue?vue&type=template&id=1913a861&"
import script from "./WorkOrdersList.vue?vue&type=script&lang=js&"
export * from "./WorkOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports